import { IPlanExtra } from "./types";

export const HUMANIZED_PLAN_ALIASES = {
  starter: "Starter",
  "starter-yearly": "Starter (Annual)",
  "pro-cloud": "Pro Cloud",
  "pro-cloud-yearly": "Pro Cloud (Annual)",
  "pro-self-hosted": "Pro Self-Hosted",
  "pro-self-hosted-yearly": "Pro Self-Hosted (Annual)",
};

const PLAN_STARTER: IPlanExtra = {
  billing_details_name: "Cloud Starter Plan",
  short_name: "Starter",
  descriptionSell: "Perfect for small teams or individuals",
  descriptionAlt:
    "Get a managed and fully-supported cloud-hosted instance of Metabase.",
  includes: [
    {
      checked: true,
      description: "Unlimited charts and dashboards",
    },
    {
      checked: true,
      description: "Connect to 20+ database types",
    },
    {
      checked: true,
      description: "Use 15+ visualizations",
    },
    {
      checked: true,
      description: "Ready to migrate from Open Source Plans",
    },
    {
      checked: false,
      description: "Basic SSO",
    },
    {
      checked: false,
      description: "Limited Embedding",
    },
    {
      checked: false,
      description: "Basic Permissions",
    },
  ],
  includesAlt: [
    {
      checked: true,
      description: "Automated upgrades and backups",
    },
    {
      checked: true,
      description: "Out-of-the-box SMTP server",
    },
    {
      checked: true,
      description: "Migrate from open source",
    },
    {
      checked: false,
      description:
        "Single sign-on with user-group mapping via SAML, LDAP or JWT",
    },
    {
      checked: false,
      description: "Interactive Embedding: white label UI, colors, and logos",
    },
  ],
  support: "3-day email",
};

const PLAN_PRO_CLOUD: IPlanExtra = {
  billing_details_name: "Pro Cloud",
  short_name: "Pro Cloud",
  descriptionSell: "For larger teams & advanced use cases",
  descriptionAlt:
    "Get extra features for embedding, managing users, and compliance.",
  includes: [
    {
      checked: true,
      description: "Unlimited charts and dashboards",
    },
    {
      checked: true,
      description: "Connect to 20+ database types",
    },
    {
      checked: true,
      description: "Use 15+ visualizations",
    },
    {
      checked: true,
      description: "Single sign-on via SAML, JWT, or advanced LDAP",
    },
    {
      checked: true,
      description: "Interactive embedding",
    },
    {
      checked: true,
      description: "Whitelabeling; customize logo, colors, and more",
    },
    {
      checked: true,
      description: "Row-level permissions",
    },
    {
      checked: true,
      description: "Self-hosted or Metabase Cloud deployment",
    },
    {
      checked: true,
      description: "Ready to migrate from open source instances",
    },
    {
      checked: true,
      description: "Custom domain",
    },
  ],
  includesAlt: [
    {
      checked: true,
      description: "Automated upgrades and backups",
    },
    {
      checked: true,
      description: "Out-of-the-box SMTP server",
    },
    {
      checked: true,
      description: "Migrate from open source",
    },
    {
      checked: true,
      description:
        "Single sign-on and user-group permissions mapping via SAML, LDAP or JWT",
    },
    {
      checked: true,
      description:
        "Granular row- and column-level permissions via [Data Sandboxing](Granular control over permissions that let you set strong boundaries around your data)",
    },
    {
      checked: true,
      description:
        "Granular results caching controls for faster, more responsive dashboards",
    },
    {
      checked: true,
      description:
        "Create separate staging and production environments with content and configuration version control via [Serialization](Export and import content from your Metabase)",
    },
    {
      checked: true,
      description:
        "Track the usage and performance of your Metabase with Usage [Analytics](A special collection offering total visibility into what’s going on in your instance)",
    },
    {
      checked: true,
      description:
        "Customize the appearance of your instance, including custom colors and fonts",
    },
    {
      checked: true,
      description:
        "Also includes [Interactive Embedding](The full power of Metabase in your app, matching your branding (The most awesome version of embedding)) and [Static Embedding](Basic embedding of dashboards and visualizations), without the “Powered by Metabase” badge",
    },
  ],
  support: "3-day email",
};

const PLAN_PRO_SELF_HOSTED: IPlanExtra = {
  billing_details_name: "Pro Self-Hosted",
  short_name: "Pro Self-Hosted",
  descriptionSell: "For larger teams & advanced use cases",
  descriptionAlt:
    "Get extra features for embedding, managing users, and compliance.",
  includes: [
    {
      checked: true,
      description: "Unlimited charts and dashboards",
    },
    {
      checked: true,
      description: "Connect to 20+ database types",
    },
    {
      checked: true,
      description: "Use 15+ visualizations",
    },
    {
      checked: true,
      description: "Single sign-on via SAML, JWT, or advanced LDAP",
    },
    {
      checked: true,
      description: "Interactive embedding",
    },
    {
      checked: true,
      description: "Whitelabeling; customize logo, colors, and more",
    },
    {
      checked: true,
      description: "Row-level permissions",
    },
    {
      checked: true,
      description: "Self-hosted or Metabase Cloud deployment",
    },
    {
      checked: true,
      description: "Ready to migrate from open source instances",
    },
    {
      checked: true,
      description: "Custom domain",
    },
  ],
  includesAlt: [
    {
      checked: true,
      description: "Automated upgrades and backups",
    },
    {
      checked: true,
      description: "Out-of-the-box SMTP server",
    },
    {
      checked: true,
      description: "Migrate from open source",
    },
    {
      checked: true,
      description:
        "Single sign-on and user-group permissions mapping via SAML, LDAP or JWT",
    },
    {
      checked: true,
      description:
        "Granular row- and column-level permissions via [Data Sandboxing](Granular control over permissions that let you set strong boundaries around your data)",
    },
    {
      checked: true,
      description:
        "Granular results caching controls for faster, more responsive dashboards",
    },
    {
      checked: true,
      description:
        "Create separate staging and production environments with content and configuration version control via [Serialization](Export and import content from your Metabase)",
    },
    {
      checked: true,
      description:
        "Track the usage and performance of your Metabase with Usage [Analytics](A special collection offering total visibility into what’s going on in your instance)",
    },
    {
      checked: true,
      description:
        "Customize the appearance of your instance, including custom colors and fonts",
    },
    {
      checked: true,
      description:
        "Also includes [Interactive Embedding](The full power of Metabase in your app, matching your branding (The most awesome version of embedding)) and [Static Embedding](Basic embedding of dashboards and visualizations), without the “Powered by Metabase” badge",
    },
  ],
  support: "3-day email",
};

export const PLAN_EXTRAS = {
  // starter
  starter: PLAN_STARTER,
  "starter-yearly": { ...PLAN_STARTER },

  // pro cloud
  "pro-cloud": PLAN_PRO_CLOUD,
  "pro-cloud-yearly": { ...PLAN_PRO_CLOUD },

  // pro self-hosted
  "pro-self-hosted": PLAN_PRO_SELF_HOSTED,
  "pro-self-hosted-yearly": { ...PLAN_PRO_SELF_HOSTED },
} as const;
